<template>
    <router-view></router-view>
</template>

<script type="text/babel">

  export default {
    name: "Edit",
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// client/views/Edit/Edit.vue